import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 存储用户信息
export const handleUser = {
  get: (name) => {
    const db_ = localStorage.getItem(name)
    return JSON.parse(db_)
  },
  remove: (name) => {
    return localStorage.removeItem(name)
  },
  set: (name, data) => {
    localStorage.setItem(name, JSON.stringify(data))
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js